import React, { useState, useEffect } from 'react';
import { formatCurrency, parseCurrency, useEscapeClose } from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';

const ItemWhModal = ({ formDetailList, showItemModal, handleItemClose, itemDataList, onRowSelectItem }) => {
    // สถานะการค้นหา
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredItemDataList, setFilteredItemDataList] = useState(itemDataList);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);

    useEscapeClose(showItemModal, handleItemClose);

    // เพิ่ม keyboard navigation สำหรับ checkbox modal
    useModalKeyboardNavigation(
        showItemModal,
        filteredItemDataList,
        selectedRowIndex,
        setSelectedRowIndex,
        null, // ไม่ใช้ default onRowSelect
        handleItemClose,
        {
            customSpaceHandler: () => {
                if (filteredItemDataList[selectedRowIndex]) {
                    handleCheckboxChange(filteredItemDataList[selectedRowIndex]);
                }
            },
            customEnterHandler: () => {
                onRowSelectItem(selectedItems);
            },
            enableSpace: true,
            includeHighlightedOnEnter: true,
            selectedItems: selectedItems
        }
    );

    useEffect(() => {
        if (showItemModal) {
            setSearchTerm('');
        }
    }, [showItemModal]);

    useEffect(() => {
        if (!itemDataList || !Array.isArray(itemDataList)) {
            setFilteredItemDataList([]);
            return;
        }

        const filteredList = itemDataList.filter(item => {
            const matchesSearchTerm =
                item.Item_Code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.Item_Name.toLowerCase().includes(searchTerm.toLowerCase());

            if (window.location.pathname === '/icebox'
                || window.location.pathname === '/technical-equip-form'
                || window.location.pathname === '/office-equip-form'
            ) {
                return matchesSearchTerm && parseCurrency(item.Item_Onhand) > 0;
            }

            return matchesSearchTerm;
        });

        setFilteredItemDataList(filteredList);
    }, [searchTerm, itemDataList]);

    useEffect(() => {
        if (showItemModal && formDetailList && Array.isArray(formDetailList) && itemDataList && Array.isArray(itemDataList)) {
            setSelectedItems(
                formDetailList.map((item) =>
                    itemDataList.find((filtered) => filtered.Item_Id === item.itemId)
                ).filter(Boolean)
            );
        } else {
            setSelectedItems([]);
        }
    }, [showItemModal, formDetailList, itemDataList]);

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            setSelectedItems(filteredItemDataList);
        } else {
            setSelectedItems([]);
        }
    };

    const handleCheckboxChange = (item) => {
        const isSelected = selectedItems.some((selected) => selected.Item_Id === item.Item_Id);
        if (isSelected) {
            setSelectedItems((prevSelected) =>
                prevSelected.filter((selected) => selected.Item_Id !== item.Item_Id)
            );
        } else {
            setSelectedItems((prevSelected) => [...prevSelected, item]);
        }
    };

    return (
        <>
            <div
                className={`modal ${showItemModal ? 'show' : ''}`}
                style={{ display: showItemModal ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อสินค้าในคลัง</h5>
                            <button type="button" className="close" onClick={handleItemClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="ค้นหา รหัสสินค้า หรือ ชื่อสินค้า"
                                    value={searchTerm || ''}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: "5%" }}>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                                    checked={
                                                        filteredItemDataList.length > 0 &&
                                                        selectedItems.length === filteredItemDataList.length
                                                    }
                                                />
                                            </th>
                                            <th className="text-center" style={{ width: '226px' }}>รหัสสินค้า</th>
                                            <th className="text-center" style={{ width: '529px' }}>ชื่อสินค้า</th>
                                            <th className="text-center" style={{ width: '529px' }}>สินค้าคงเหลือ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredItemDataList && filteredItemDataList.length > 0 ? (
                                            filteredItemDataList.map((item, index) => (
                                                <tr
                                                    key={item.Item_Id || index + 1}
                                                    onClick={() => {
                                                        setSelectedRowIndex(index);
                                                        handleCheckboxChange(item);
                                                    }}
                                                    style={{
                                                        cursor: 'pointer',
                                                        backgroundColor: index === selectedRowIndex || selectedItems.some(selectedItem => selectedItem.Item_Id === item.Item_Id)
                                                            ? 'rgb(105, 188, 216)'
                                                            : 'transparent',
                                                        transition: 'background-color 0.3s ease',
                                                    }}
                                                >
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedItems.some((selected) => selected.Item_Id === item.Item_Id)}
                                                            onChange={() => handleCheckboxChange(item)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </td>
                                                    <td className="text-center">{item.Item_Code}</td>
                                                    <td className="text-left">{item.Item_Name}</td>
                                                    <td className="text-left">{formatCurrency(item.Item_Onhand)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="text-left" style={{ fontSize: "12px", color: "#666", marginRight: "auto" }}>
                                {getKeyboardInstructions('สินค้า', true)}
                            </div>
                            <button className="btn btn-primary" onClick={() => {
                                onRowSelectItem(selectedItems);
                            }}
                            //disabled={selectedItems.length === 0} // คอมเม้นไว้ก่อน ใช้สำหรับ Disabled เมื่อยังไม่ได้เลือกสินค้า
                            >
                                ยืนยัน (Enter)
                            </button>
                            <button className="btn btn-danger" onClick={handleItemClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {showItemModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default ItemWhModal;